/* Simply Active — header helpers, cart drawer, search overlay, colour pills */
(function () {
  if (window.__saCartInit) return;
  window.__saCartInit = true;

  var COLOURS = {ink:'#1E2230',mocha:'#8A6A55',ash:'#8E8D88',oat:'#D8CCB8',mist:'#B9C3C4',sage:'#8D9479',cherry:'#6E1F2A',honey:'#C8964F',taro:'#B7A3C4',blush:'#E6C2BD',amber:'#B8743A',cream:'#EFE7D6'};

  var fix = document.createElement('style');
  fix.textContent = '.sa-cart__checkout,.sa-cart__checkout *{color:#f4f2ed!important}.sa-cart__checkout:hover{opacity:.9}' +
    '.sa-card__swatches{height:auto!important;padding:4px 4px 6px!important;margin:0 -4px!important;overflow:visible!important}' +
    '.sa-rail__track{padding-bottom:8px!important}' +
    '.sa-colour-pill{position:relative;padding-left:14px!important;padding-right:14px!important;border-color:transparent!important;font-weight:600}' +
    '.sa-colour-pill .sa-filter-count{opacity:.7}' +
    '.sa-colour-pill.is-light{box-shadow:inset 0 0 0 1px rgba(21,21,15,.18)}' +
    '.sa-colour-pill:has(input:checked){box-shadow:0 0 0 2px #15150f}';
  document.head.appendChild(fix);

  var me = document.querySelector('script[src*="sa-cart.js"]');
  if (me) {
    var brand = document.createElement('link');
    brand.rel = 'stylesheet';
    brand.href = me.src.replace('sa-cart.js', 'sa-klarna.css').replace(/\?v=\d+/, '') + '?v=' + Math.floor(Date.now() / 3e5);
    document.head.appendChild(brand);
  }

  var money = function (cents, currency) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100).replace('.00', '');
    } catch (e) { return '£' + (cents / 100).toFixed(2); }
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) { return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function textOn(hex) {
    var c = hex.replace('#', '');
    var r = parseInt(c.slice(0, 2), 16) / 255, g = parseInt(c.slice(2, 4), 16) / 255, b = parseInt(c.slice(4, 6), 16) / 255;
    function lin(v) { return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    var L = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
    return L > 0.45 ? '#15150f' : '#ffffff';
  }

  function paintColourPills() {
    document.querySelectorAll('.sa-filter-group').forEach(function (group) {
      var sum = group.querySelector('summary');
      if (!sum || !/^\s*colou?r\b/i.test(sum.textContent)) return;
      group.querySelectorAll('.sa-filter-option').forEach(function (label) {
        var name = (label.querySelector('span') || {}).textContent || '';
        var hex = COLOURS[name.trim().toLowerCase()];
        if (!hex) return;
        var fg = textOn(hex);
        label.classList.add('sa-colour-pill');
        if (fg === '#15150f') label.classList.add('is-light');
        label.style.background = hex;
        label.style.color = fg;
        label.querySelectorAll('span,em').forEach(function (n) { n.style.color = fg; });
      });
    });
  }

  ready(function () {
    document.querySelectorAll('.sa-mm').forEach(function (mm) {
      var prev = mm.querySelector('.sa-mm__preview');
      var all = mm.querySelector('.sa-mm__all');
      if (all) all.textContent = all.textContent.replace(/Shop all Shop by /i, 'Shop all ');
      if (!prev) return;
      function label(a) { var s = a && a.querySelector('span'); prev.setAttribute('data-label', s ? s.textContent.trim() : ''); }
      var links = mm.querySelectorAll('.sa-mm__link');
      label(links[0]);
      links.forEach(function (a) { a.addEventListener('mouseenter', function () { label(a); }); });
    });
    document.querySelectorAll('.sa-benefits__note').forEach(function (n) {
      if (/30 days/i.test(n.textContent)) n.textContent = '14 days to exchange';
    });
    document.querySelectorAll('.sa-social__heading p').forEach(function (p) {
      p.textContent = p.textContent.replace(/@simplyactive\b/i, '@simplyactiv_official');
    });
    paintColourPills();
    buildSearch();
  });
  document.addEventListener('click', function (e) { if (e.target.closest('.sa-filter-open')) setTimeout(paintColourPills, 60); });

  var header = document.querySelector('[data-sa-header]');
  if (header) {
    var isStatic = header.hasAttribute('data-sa-static');
    var solidAt = function () { return Math.max(180, window.innerHeight * 0.62); };
    var onScroll = function () {
      if (isStatic) { header.classList.add('is-solid'); return; }
      header.classList.toggle('is-solid', window.scrollY > solidAt());
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    header.addEventListener('mouseover', function (e) {
      if (e.target.closest('.sa-header__navitem')) header.classList.add('is-solid');
    });
    header.addEventListener('mouseleave', function () { onScroll(); });
  }

  var cart = document.querySelector('[data-sa-cart]');
  var latestCart = null;
  var threshold = cart ? Math.round(parseFloat(cart.getAttribute('data-threshold') || '50') * 100) : 5000;

  function ensureExtras() {
    if (!cart || cart.querySelector('.sa-cx')) return;
    var head = cart.querySelector('.sa-cart__head');
    var prog = document.createElement('div');
    prog.className = 'sa-cx sa-cx__ship';
    prog.innerHTML = '<p class="sa-cx__shiptext" data-sa-cx-shiptext></p><div class="sa-cx__bar"><i data-sa-cx-bar></i></div>';
    head.parentNode.insertBefore(prog, head.nextSibling);
    var foot = cart.querySelector('.sa-cart__foot');
    var up = document.createElement('div');
    up.className = 'sa-cx__up'; up.setAttribute('data-sa-cx-up', ''); up.hidden = true;
    foot.parentNode.insertBefore(up, foot);
    var note = document.createElement('p');
    note.className = 'sa-cx__note';
    note.textContent = 'Sign up to get 12% off your first order.';
    var form = foot.querySelector('form');
    foot.insertBefore(note, form);
    var old = foot.querySelector('[data-sa-shipping]'); if (old) old.style.display = 'none';
  }

  function setCart(open) {
    if (!cart) return;
    cart.classList.toggle('is-open', open);
    if (open && latestCart) renderUpsell(latestCart);
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var close = cart.querySelector('.sa-cart__close'); if (close && close.focus) close.focus(); }
  }

  function renderShip(total) {
    var t = cart.querySelector('[data-sa-cx-shiptext]'), b = cart.querySelector('[data-sa-cx-bar]');
    if (!t || !b) return;
    var left = threshold - total;
    b.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
    t.innerHTML = left <= 0 ? '🎉 You’ve unlocked <strong>free UK delivery</strong>' : 'You’re <strong>' + money(left) + '</strong> away from free UK delivery';
    cart.querySelector('.sa-cx__ship').classList.toggle('is-done', left <= 0);
  }

  function renderUpsell(data) {
    var box = cart.querySelector('[data-sa-cx-up]');
    if (!box) return;
    if (!data.items.length) { box.hidden = true; return; }
    var inCart = data.items.map(function (i) { return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + data.items[0].product_id + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d.products || []).filter(function (p) { return inCart.indexOf(p.id) < 0 && p.available; }).slice(0, 6);
        if (!ps.length) { box.hidden = true; return; }
        box.hidden = false;
        box.innerHTML = '<p class="sa-cx__uphead">Complete your look</p><div class="sa-cx__uprail">' + ps.map(function (p) {
          return '<a class="sa-cx__upcard" href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 240)) + '" alt="" loading="lazy" width="96" height="120"><span class="sa-cx__upname">' + esc(p.title) + '</span><span class="sa-cx__upprice">' + money(p.price) + '</span></a>';
        }).join('') + '</div>';
      }).catch(function () { box.hidden = true; });
  }

  function render(data) {
    if (!cart) return;
    latestCart = data;
    ensureExtras();
    var cur = data.currency || 'GBP';
    document.querySelectorAll('[data-sa-bagcount]').forEach(function (n) { n.textContent = data.item_count; });
    var body = cart.querySelector('[data-sa-cart-body]');
    if (body) {
      if (!data.items.length) {
        body.innerHTML = '<div class="sa-cart__empty sa-cx__empty"><p>Your bag is empty.</p><a href="/collections/new-in" class="sa-cx__emptybtn">Shop new in</a><a href="/collections/active-sets" class="sa-cx__emptylink">Shop active sets</a></div>';
      } else {
        body.innerHTML = data.items.map(function (item) {
          var im = item.image ? '<img class="sa-cart__plate" src="' + esc(img(item.image, 200)) + '" alt="" width="64" height="82" loading="lazy">' : '<span class="sa-cart__plate"></span>';
          var was = item.original_line_price > item.final_line_price ? '<s class="sa-cx__was">' + money(item.original_line_price, cur) + '</s>' : '';
          return '<div class="sa-cart__line" data-sa-line="' + item.key + '">' + '<a href="' + esc(item.url) + '">' + im + '</a>' +
            '<div class="sa-cart__linebody"><div class="sa-cart__linetop">' +
            '<a class="sa-cart__linename" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            '<span class="sa-cart__lineprice">' + was + money(item.final_line_price, cur) + '</span></div>' +
            '<div class="sa-cart__linemeta">' + esc(item.variant_title || '') + '</div>' +
            '<div class="sa-cx__row"><div class="sa-cx__qty"><button type="button" data-sa-qty="' + item.key + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease">−</button><span>' + item.quantity + '</span><button type="button" data-sa-qty="' + item.key + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase">+</button></div>' +
            '<button type="button" class="sa-cart__remove" data-sa-remove="' + item.key + '">Remove</button></div>' +
            '</div></div>';
        }).join('');
      }
    }
    var sub = cart.querySelector('[data-sa-subtotal]');
    if (sub) sub.textContent = money(data.total_price, cur);
    renderShip(data.total_price);
    if (cart.classList.contains('is-open')) renderUpsell(data);
  }

  function refresh(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { render(d); if (open) setCart(true); })
      .catch(function () {});
  }

  function change(key, qty) {
    cart && cart.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) { render(d); })
      .catch(function () {})
      .then(function () { cart && cart.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sa-cart-open]')) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('[data-sa-cart-close]')) { setCart(false); return; }
    var rm = e.target.closest('[data-sa-remove]');
    if (rm) { change(rm.getAttribute('data-sa-remove'), 0); return; }
    var q = e.target.closest('[data-sa-qty]');
    if (q) { change(q.getAttribute('data-sa-qty'), parseInt(q.getAttribute('data-q'), 10)); return; }
    var s = e.target.closest('a[href$="/search"], a[href="/search"], [data-sa-search-open]');
    if (s && document.querySelector('[data-sa-search]')) { e.preventDefault(); openSearch(); return; }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setCart(false); closeSearch(); } });
  document.addEventListener('sa:cart:added', function () { refresh(true); });
  if (cart) refresh(false);

  var sbox, sinput, sres, stimer;
  function buildSearch() {
    if (document.querySelector('[data-sa-search]')) return;
    sbox = document.createElement('div');
    sbox.className = 'sa-sx'; sbox.setAttribute('data-sa-search', ''); sbox.hidden = true;
    sbox.innerHTML =
      '<div class="sa-sx__scrim" data-sa-sx-close></div>' +
      '<div class="sa-sx__panel" role="dialog" aria-modal="true" aria-label="Search">' +
        '<form class="sa-sx__form" action="/search" method="get" role="search">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.6"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          '<input type="search" name="q" placeholder="Search leggings, sets, colours…" autocomplete="off" aria-label="Search">' +
          '<input type="hidden" name="options[prefix]" value="last">' +
          '<button type="button" class="sa-sx__close" data-sa-sx-close aria-label="Close search">&times;</button>' +
        '</form>' +
        '<div class="sa-sx__res" data-sa-sx-res></div>' +
      '</div>';
    document.body.appendChild(sbox);
    sinput = sbox.querySelector('input[type="search"]');
    sres = sbox.querySelector('[data-sa-sx-res]');
    idle();
    sbox.addEventListener('click', function (e) {
      if (e.target.closest('[data-sa-sx-close]')) { closeSearch(); return; }
      var chip = e.target.closest('[data-sa-sx-term]');
      if (chip) { sinput.value = chip.getAttribute('data-sa-sx-term'); sinput.dispatchEvent(new Event('input')); sinput.focus(); }
    });
    sinput.addEventListener('input', function () {
      clearTimeout(stimer);
      var q = sinput.value.trim();
      if (q.length < 2) { idle(); return; }
      stimer = setTimeout(function () { query(q); }, 180);
    });
  }
  function idle() {
    var terms = ['Leggings', 'Active sets', 'Sports bras', 'Flared', 'Pilates', 'Shorts', 'Hoodies'];
    sres.innerHTML = '<p class="sa-sx__label">Popular searches</p><div class="sa-sx__chips">' + terms.map(function (t) { return '<button type="button" data-sa-sx-term="' + t + '">' + t + '</button>'; }).join('') + '</div>' +
      '<p class="sa-sx__label">Shop by colour</p><div class="sa-sx__chips">' + Object.keys(COLOURS).map(function (c) {
        var hex = COLOURS[c];
        return '<a href="/collections/' + c + '" style="background:' + hex + ';color:' + textOn(hex) + ';border-color:transparent">' + c.charAt(0).toUpperCase() + c.slice(1) + '</a>';
      }).join('') + '</div>';
  }
  function query(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var r = (d.resources && d.resources.results) || {}, ps = r.products || [], cs = r.collections || [];
        function decode(t) { var n = document.createElement('textarea'); n.innerHTML = t || ''; return n.value; }
        if (!ps.length && !cs.length) { sres.innerHTML = '<p class="sa-sx__none">No results for “' + esc(q) + '”. Try “leggings” or “sets”.</p>'; return; }
        sres.innerHTML =
          (cs.length ? '<p class="sa-sx__label">Collections</p><div class="sa-sx__chips">' + cs.slice(0, 5).map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(decode(c.title)) + '</a>'; }).join('') + '</div>' : '') +
          (ps.length ? '<p class="sa-sx__label">Products</p><div class="sa-sx__grid">' + ps.map(function (p) {
            return '<a class="sa-sx__card" href="' + esc(p.url) + '"><span class="sa-sx__img"><img src="' + esc(img(p.image, 400)) + '" alt="" loading="lazy"></span><span class="sa-sx__name">' + esc(decode(p.title)) + '</span><span class="sa-sx__price">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
          }).join('') + '</div>' : '') +
          '<a class="sa-sx__all" href="/search?q=' + encodeURIComponent(q) + '&options[prefix]=last">See all results for “' + esc(q) + '” →</a>';
      }).catch(function () {});
  }
  function openSearch() {
    if (!sbox) buildSearch();
    sbox.hidden = false;
    requestAnimationFrame(function () { sbox.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { sinput.focus(); }, 60);
  }
  function closeSearch() {
    if (!sbox || sbox.hidden) return;
    sbox.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { sbox.hidden = true; }, 220);
  }
})();
